// 고객용 앱 스토어 URL
export const APP_STORE_URL = 'https://apps.apple.com/app/id6751527247';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.beneficial.olym.app';

// 관리자용 앱 스토어 URL
export const ADMIN_APP_STORE_URL = 'https://apps.apple.com/app/id6757894768';
export const ADMIN_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.beneficial.olym.admin.app';

// OS 감지
export function detectOS() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  return 'desktop';
}

// OS에 따른 고객용 앱 스토어 URL 반환
export function getStoreUrl(os) {
  if (os === 'ios') {
    return APP_STORE_URL;
  }
  if (os === 'android') {
    return PLAY_STORE_URL;
  }
  return null;
}

// OS에 따른 관리자용 앱 스토어 URL 반환
export function getAdminStoreUrl(os) {
  if (os === 'ios') {
    return ADMIN_APP_STORE_URL;
  }
  if (os === 'android') {
    return ADMIN_PLAY_STORE_URL;
  }
  return null;
}

// 스토어로 리다이렉트
export function redirectToStore(os) {
  const url = getStoreUrl(os);
  if (url) {
    window.location.href = url;
    return true;
  }
  return false;
}

// 딥링크 URL 생성
export function getDeepLinkUrl(path) {
  return `olym://${path}`;
}

// 딥링크만 시도 (스토어 자동 이동 없음)
export function tryDeepLink(path, os) {
  if (os === 'desktop') {
    return false;
  }

  const deepLinkUrl = getDeepLinkUrl(path);

  // 딥링크 시도
  window.location.href = deepLinkUrl;

  return true;
}

// 딥링크 시도 후 실패 시 스토어로 이동
export function tryDeepLinkOrStore(path, os, fallbackDelay = 1500) {
  if (os === 'desktop') {
    return false;
  }

  const deepLinkUrl = getDeepLinkUrl(path);
  const storeUrl = getStoreUrl(os);

  // 딥링크 시도
  window.location.href = deepLinkUrl;

  // 앱이 없으면 스토어로 이동 (딥링크 실패 시 페이지가 그대로 있음)
  setTimeout(() => {
    // 페이지가 아직 보이면 앱이 열리지 않은 것
    if (!document.hidden) {
      window.location.href = storeUrl;
    }
  }, fallbackDelay);

  return true;
}
